'use strict';
define([
    'angular',
    'modules/seochecker/landing/landing.controller'
],function(angular, SCLandingCtrl){
    var app=angular.module('app.seochecker.landing', []);
    app.controller('SCLandingCtrl',SCLandingCtrl);
    return app;
});